import { module } from 'modujs';
import { Swiper, Pagination, Navigation } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.container  = this.$('container')[0];
        this.pagination = this.$('pagination')[0];

        this.carousel = new Swiper(this.container, {
            modules: [
                Pagination,
                Navigation,
            ],
            speed: 600,
            loop: false,
            slideToClickedSlide: true,
            grabCursor: true,
            spaceBetween: '9%',
            slidesPerView: 1,
            slidesPerGroup: 1,
            pagination: {
                el: this.pagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                prevEl: this.$('arrow-prev')[0],
                nextEl: this.$('arrow-next')[0]
            },
            breakpoints: {
                699: {
                    slidesPerGroup: 2,
                    slidesPerView: 2,
                },
                // when window width is <= 999px
                999: {
                    slidesPerGroup: 3,
                    slidesPerView: 3,
                }
            },
            on: {
                paginationUpdate: (swiper, paginationEl) => {
                    if (paginationEl.children.length < 2) {
                        paginationEl.classList.add('-single-page');
                    } else {
                        paginationEl.classList.remove('-single-page');
                    }
                }
            }
        });
    }

    destroy() {
        if (this.carousel && this.carousel.destroy) {
            this.carousel.destroy();
        }
    }
}
